import React from 'react'

import { Box } from '~/components/elements/Box'
import { VStack } from '~/components/elements/VStack'
import { type Brand } from '~/hooks/useSurveyQuery'
import { nineSegments } from '~/utils'

import { BrandNineSegmentButton } from './BrandNineSegmentButton'
import styles from './BrandNineSegmentPanel.css'

export type BrandNineSegmentPanelProps = {
  brand: Brand
}

export const BrandNineSegmentPanel = ({
  brand,
}: BrandNineSegmentPanelProps) => (
  <VStack backgroundColor="transparent" spacing={1}>
    <span className={styles.label}>{`${brand.number}: ${brand.name}`}</span>

    <Box className={styles.panel}>
      {nineSegments.map((nineSegment) => (
        <BrandNineSegmentButton
          key={nineSegment}
          brand={brand}
          className={styles[nineSegment]}
          nineSegment={nineSegment}
        />
      ))}
    </Box>
  </VStack>
)
